module.exports = __webpack_public_path__ + "static/media/loader.9c9be885.gif";